module.exports = __webpack_public_path__ + "img/august_1920.d831defc.png";